import { render } from "./Step_two.vue?vue&type=template&id=4e9e7a46"
import script from "./Step_two.vue?vue&type=script&lang=js"
export * from "./Step_two.vue?vue&type=script&lang=js"

import "./Step_two.vue?vue&type=style&index=0&id=4e9e7a46&lang=less"
script.render = render

export default script